import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Al cambiar de ruta, hace scroll al inicio de la nueva página.
// Respeta anclas (#id) para que la navegación con hash siga funcionando.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Delay para dar tiempo a que el DOM renderice el destino
      const id = hash.replace("#", "");
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "auto", block: "start" });
      });
      return;
    }
    // Deshabilitar temporalmente el scroll-behavior:smooth del CSS para saltar al top instantáneamente
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    html.style.scrollBehavior = prev;
  }, [pathname, hash]);

  return null;
}
